import { Controller } from 'stimulus';
import dataLayer from '../helpers/dataLayer';

const percentageHit = {
  25: false,
  50: false,
  75: false,
  95: false,
};

class HomeVideoController extends Controller {
  connect() {
    this.playerInitialized = false;
    this.isPlaying = false;
    this.interval = setInterval(() => {
      this.checkPlayerProgress();
    }, 1000);

    $(this.element).on('show.bs.modal', this.openVideoModal.bind(this));
    $(this.element).on('hidden.bs.modal', this.onVideoModalClose.bind(this));

    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);
  }

  disconnect() {
    $(this.element).off('show.bs.modal', this.openVideoModal.bind(this));
    $(this.element).off('hidden.bs.modal', this.onVideoModalClose.bind(this));

    if (typeof this.interval !== 'undefined') {
      clearInterval(this.interval);
    }
  }

  openVideoModal() {
    dataLayer.event('Home video loaded', 'loaded');

    this.initializeYTApi();
  }

  onVideoModalClose() {
    if (typeof this.player !== 'undefined' && typeof this.player.pauseVideo === 'function') {
      this.player.pauseVideo();
    }
  }

  initializeYTApi() {
    if (typeof window.YT !== 'undefined') {
      this.onYouTubeIframeAPIReady();
      return;
    }

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  onYouTubeIframeAPIReady() {
    if (this.playerInitialized) {
      this.onPlayerReady();
      return;
    }

    this.playerInitialized = true;

    this.player = new window.YT.Player(this.videoTarget, {
      height: '390',
      width: '640',
      videoId: 'eSeYllTKtPk',
      playerVars: {
        playsinline: 1,
        rel: 0,
      },
      events: {
        onReady: this.onPlayerReady.bind(this),
        onStateChange: this.onPlayerStateChange.bind(this),
      },
    });
  }

  onPlayerReady() {
    this.player.playVideo();
  }

  onPlayerStateChange(event) {
    this.isPlaying = event.data === window.YT.PlayerState.PLAYING;
  }

  checkPlayerProgress() {
    if (!this.isPlaying || typeof this.player === 'undefined') {
      return;
    }

    const progress = (this.player.getCurrentTime() / this.player.getDuration()) * 100;

    Object.keys(percentageHit).forEach((percentage) => {
      const isHit = percentageHit[percentage];

      if (!isHit) {
        if (progress >= percentage) {
          percentageHit[percentage] = true;

          dataLayer.event('Home video progress', 'progress', percentage);
        }
      }
    });
  }
}

HomeVideoController.targets = [
  'video',
];

export default HomeVideoController;
